import { z } from 'zod'
import { DateTime } from 'luxon'

export const SchoolYearSchema = z.object({
  schoolYearId: z.number(),
  startDate: z.string(),
  endDate: z.string(),
  name: z.string(),
  isCurrent: z.boolean()
}).transform((data) => {
  const start = DateTime.fromISO(data.startDate);
  const end = DateTime.fromISO(data.endDate);
  const now = DateTime.now();

  return {
    ...data,
    isPast: now > end,
    isFuture: now < start,
  };
});

export const SchoolYearListSchema = z.array(SchoolYearSchema)

export type SchoolYearEntity = z.infer<typeof SchoolYearSchema>
export type SchoolYearListEntity = z.infer<typeof SchoolYearListSchema>
